// @ts-check
import { Input } from "antd";
import Button from '~/components/Shared/Button';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import logo from '~/assets/css/img/ZERO-(white)-small.png';
import { kiosk_activate_using_key, prevent401Redirect, update_auth_token } from '~/api/zero-api';
import { getParamFromLocation } from '~/other/Helper';

export default function KioskActivation() {
    const { uuid, activation_key } = useParams();
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [activationFailed, setActivationFailed] = useState(false);

    const activateKiosk = async () => {
        const body = {
            activation_key_uuid: uuid,
            activation_key,
            activation_code: code,
        }
        try {
            setActivationFailed(false);
            setLoading(true);
            await prevent401Redirect(async () => {
                const res = await kiosk_activate_using_key(body);
                const content = await res.json();
                update_auth_token(content.kiosk_mode_token);
                window.location.href = "/kiosk_mode";
            });
        } catch (err) {
            setActivationFailed(true);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div id="container" className="cls-container auth">
            <div className="cls-content">
                <div
                    className="cls-content-sm panel img"
                    style={{
                        background: "none",
                        boxShadow: "none",
                        border: "none",
                        height: "160px",
                    }}
                >
                    <img src={logo} alt="ZERO Logo" style={{ height: "140px" }} />
                </div>
                <div className="panel" style={{ maxWidth: "400px", margin: "0 auto" }}>
                    <div className="panel-body flex-col gap-md zero-blue">
                        <h3>Kiosk Activation</h3>
                        <p>If you have an activation code, enter it below.</p>
                        <Input
                            placeholder="Activation Code (optional)"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            type="password"
                            autoComplete="off"
                        />
                        {activationFailed && <small className="error">Activation failed. Please try again.</small>}
                        <Button type="primary" onClick={() => activateKiosk()} loading={loading}>
                            Activate
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
